module.exports = "/out/2b610786031b240ec2cece8f7057f49e.svg";